export default "__VITE_ASSET__VXtsVot5__"